"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _expansionPanel = _interopRequireDefault(require("../expansion-panel"));

var _divider = _interopRequireDefault(require("../divider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Accordion = function Accordion(_ref) {
  var className = _ref.className,
      controlled = _ref.controlled,
      data = _ref.data,
      disabled = _ref.disabled,
      ExpansionPanelProps = _ref.ExpansionPanelProps,
      panelWrapperClassName = _ref.panelWrapperClassName;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var togglePanel = function togglePanel(panel) {
    return function (event, isExpanded) {
      var nextState = !isExpanded ? panel : false;
      setExpanded(nextState);
    };
  };

  return _react.default.createElement("ul", {
    className: (0, _classnames.default)(className, 'pds-accordion')
  }, data.map(function (item, index) {
    var controlledProps = {};

    if (controlled) {
      controlledProps.expanded = expanded === item.id;
      controlledProps.togglePanel = togglePanel(item.id);
    }

    return _react.default.createElement("li", {
      key: item.id,
      className: (0, _classnames.default)(panelWrapperClassName, 'pds-accordion__panel-wrapper')
    }, index === 0 && _react.default.createElement(_divider.default, null), _react.default.createElement(_expansionPanel.default, _extends({}, ExpansionPanelProps, item, controlledProps, {
      disabled: disabled || item.disabled
    })), _react.default.createElement(_divider.default, null));
  }));
};

Accordion.propTypes = {
  /**
   * Applies additional CSS classes to the wrapper "ul" element over a list
   * of ExpansionPanel components.
   */
  className: _propTypes.string,

  /**
   * Indicates whether or not the Accordion component should control the
   * functionality of showing/hiding detailed content. If set to true,
   * only a single ExpansionPanel can be visible at any given time.
   */
  controlled: _propTypes.bool,

  /**
   * Array of objects that contains information to be used in each
   * `ExpansionPanel` component. See `ExpansionPanel` for a full list of
   * acceptable props.
   */
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    details: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
    header: _propTypes.string.isRequired,
    icon: _propTypes.node,
    id: _propTypes.string.isRequired
  })).isRequired,

  /**
   * Whether or not the ExpansionPanels in the Accordion can be interacted
   * with. If set to true, this will take precedence over the individual
   * `disabled` props for the Expansion Panels.
   */
  disabled: _propTypes.bool,

  /**
   * Additional props to be used by each `ExpansionPanel` component (in
   * addition to what is stored in each object from the `data` prop).
   */
  ExpansionPanelProps: (0, _propTypes.shape)({}),

  /**
   * Applies additional CSS classes to the wrapper "li" element over the
   * ExpansionPanel component; using this prop affects ALL ExpansionPanel
   * wrappers.
   */
  panelWrapperClassName: _propTypes.string
};
Accordion.defaultProps = {
  className: null,
  controlled: false,
  disabled: false,
  ExpansionPanelProps: null,
  panelWrapperClassName: null
};
var _default = Accordion;
exports.default = _default;
